import {
	GET_SNAPS,
	GET_SNAPS_SUCCESS,
	GET_SNAPS_FAILURE,
	ADD_SNAP,
	ADD_SNAP_SUCCESS,
	ADD_SNAP_FAILURE,
	EDIT_SNAP,
	EDIT_SNAP_SUCCESS,
	EDIT_SNAP_FAILURE,
	DELETE_SNAP,
	DELETE_SNAP_SUCCESS,
	DELETE_SNAP_FAILURE,
	EXPORT_SNAP,
} from './types';

export const getSnapsAction = (payload?: any) => ({
	type: GET_SNAPS,
	payload,
});

export const getSnapsSuccessAction = (payload: any) => ({
	type: GET_SNAPS_SUCCESS,
	payload,
});

export const getSnapsFailureAction = (error: Error) => ({
	type: GET_SNAPS_FAILURE,
	payload: error,
});

export const addSnapAction = (payload: any) => ({
	type: ADD_SNAP,
	payload,
});

export const addSnapSuccessAction = (payload: any) => ({
	type: ADD_SNAP_SUCCESS,
	payload,
});

export const addSnapFailureAction = (error: Error) => ({
	type: ADD_SNAP_FAILURE,
	payload: error,
});

export const editSnapAction = (payload: {
	data: any;
	callback: () => void;
}) => ({
	type: EDIT_SNAP,
	payload,
});

export const editSnapSuccessAction = (payload: any) => ({
	type: EDIT_SNAP_SUCCESS,
	payload,
});

export const editSnapFailureAction = (error: Error) => ({
	type: EDIT_SNAP_FAILURE,
	payload: error,
});

export const deleteSnapAction = (payload: any) => ({
	type: DELETE_SNAP,
	payload,
});

export const deleteSnapSuccessAction = (payload: any) => ({
	type: DELETE_SNAP_SUCCESS,
	payload,
});

export const deleteSnapFailureAction = (error: Error) => ({
	type: DELETE_SNAP_FAILURE,
	payload: error,
});

export const exportSnapAction = (payload: any) => ({
	type: EXPORT_SNAP,
	payload,
});
